import styled from 'styled-components';

const Content = styled.div`
  height: calc(${props => props.height} - ${props => (props.hideInput ? '80px' : '220px')});
  overflow-y: scroll;
  margin-top: 2px;
  padding-top: 6px;

  @media screen and (max-width: 568px) {
    height: ${props => (props.floating ? 'calc(100% - 120px)' : '')};
  }
`;

export default Content;
